import useMapEnum from "src/functions/mappers/use-map-enum";
import { ResidentialStatus_Enum } from "src/types/enums";

const residentialStatusOptions = useMapEnum(Object.values(ResidentialStatus_Enum))

export default residentialStatusOptions;
